<template>
	<div class="eno-info">
		{{info}}
	</div>
</template>

<script>
	
	import { config } from '../../../constant/config.js'
	export default {
		name: 'enoInfo',
		data() {
			return {
				info:config.headerInfo
			}
		},
		mounted() {
			// window.addEventListener("scroll", this.changeHeadBg);
		},
		methods: {
		},
	
	}
</script>

<style lang='less' scoped>
	.eno-info{
		color: @mainTextColor;
		height: 100%;
		display: flex;
		align-items: center;
	}

</style>